import React, { useMemo, useRef } from 'react';
import { Dropdown, Menu, Iconfont } from '@umu/umu-design';
import { PLACEMENT_ENUM } from '@umu/umu-design/es/components/Dropdown/interface';
import { MENU_MODE } from '@umu/umu-design/es/components/Menu/interface';
import { lang } from '@umu/ukit-lang';
import classNames from 'classnames';
import { PageFlipMode, SCREEN_STATE } from '../types';
import flippingModeIcon from '../images/flipping-mode.svg';
import { ReactSVG } from 'react-svg';
import { $document } from '@umu/umu-dom';

interface FlipModeMenuProps {
    pageFlipMode: PageFlipMode;
    screenState: SCREEN_STATE;
    className?: string;
    onFlipModeChange: (mode: PageFlipMode) => void;
}

const FlipModeMenu: React.FC<FlipModeMenuProps> = (props) => {
    const { pageFlipMode, className = '', onFlipModeChange } = props;
    const [visible, setVisible] = React.useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const menuList = useMemo(() => {
        const modes: { key: PageFlipMode; label: string }[] = [
            { key: 'horizontal', label: lang('左右翻页') },
            { key: 'vertical', label: lang('上下滚动') },
        ];

        return modes.map((mode) => ({
            key: mode.key,
            title: (
                <div className="umu-pdf-menu-item-content">
                    <div className="umu-pdf-menu-item-icon-wrapper">
                        {pageFlipMode === mode.key && <Iconfont type="Complete" />}
                    </div>
                    <span className="umu-pdf-menu-item-text">{mode.label}</span>
                </div>
            ),
        }));
    }, [pageFlipMode]);

    const menuContent = useMemo(
        () => (
            <div className="umu-pdf-flip-mode-menu">
                <div className="umu-pdf-menu-title">{lang('请选择翻页方式')}</div>
                <Menu
                    mode={MENU_MODE.VERTICAL}
                    itemClassName="umu-pdf-menu-item"
                    selectedKeys={[pageFlipMode]}
                    list={menuList}
                    onClick={({ key }: { key: string }) => onFlipModeChange(key as PageFlipMode)}
                />
            </div>
        ),
        [menuList, onFlipModeChange, pageFlipMode],
    );

    return (
        <div
            className={classNames('toolbar-flip-mode', className, {
                'is-open': visible,
            })}
            ref={containerRef}
        >
            <Dropdown
                trigger={['hover', 'click']}
                placement={PLACEMENT_ENUM.BOTTOM_RIGHT}
                overlay={menuContent}
                onVisibleChange={setVisible}
                expandConfig={{
                    getPopupContainer: () => containerRef.current || $document.body,
                    placements: {
                        bottomRight: {
                            points: ['tr', 'br'],
                            overflow: { adjustX: 1, adjustY: 0 },
                            offset: [0, 4],
                            targetOffset: [0, 0],
                        },
                    },
                }}
                overlayClassName="umu-pdf-flip-mode-dropdown"
            >
                <div className="umu-pdf-flip-mode-icon-wrapper">
                    <ReactSVG src={flippingModeIcon} />
                </div>
            </Dropdown>
        </div>
    );
};

export default FlipModeMenu;
